import "./index.css";
import "./styles/layout.css";
import "./styles/auth.css";
import "./styles/theme.css";   // ✅ import once
import "./style/global.css";

import ReactDOM from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import { Provider } from "react-redux";
import { store } from "./store/appStore";

import { ThemeProvider } from "./context/ThemeContext"; // ✅ add this

const googleClientId =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  "223046274208-a6kdoaojdcp4353ou3nclsfut4noqtst.apps.googleusercontent.com";

ReactDOM.createRoot(document.getElementById("root")).render(
  <ThemeProvider>
    <GoogleOAuthProvider clientId={googleClientId}>
      <BrowserRouter>
        <Provider store={store}>
          <App />
        </Provider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  </ThemeProvider>
);
